import { render, staticRenderFns } from "./OrderValves.vue?vue&type=template&id=4518944a"
import script from "./OrderValves.vue?vue&type=script&lang=js"
export * from "./OrderValves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports